import { ApiVersion, BaseService } from '~services/api'

export interface DataSourceUserDoctor {
  dsu_id: string
  doctor_name: string | null
}

export const GetDataSourcesUsersDoctors = (Uid: string, access: string, client: string) => {
  return BaseService.get(`/institution_api/v1/data_sources_users`, {
    timeout: 1000000,
    headers: {
      'Content-Type': 'application/json',
      Client: client,
      APP_VERSION: ApiVersion,
      Uid: Uid,
      'Access-Token': access,
    },
  })
}

export const GetMedicalProductions = (
  Uid: string,
  access: string,
  client: string,
  pageInfo: { per_page: string; page: string },
  params: Record<string, string | string[]>,
) => {
  return BaseService.get(
    `/institution_api/v1/medical_productions?per_page=${pageInfo.per_page}&page=${pageInfo.page}`,
    {
      params,
      paramsSerializer: {
        serialize: (p) => {
          const parts: string[] = []
          Object.entries(p).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              value.forEach((v) => parts.push(`${key}=${encodeURIComponent(v)}`))
            } else if (value !== undefined && value !== null && value !== '') {
              parts.push(`${key}=${encodeURIComponent(String(value))}`)
            }
          })
          return parts.join('&')
        },
      },
      timeout: 1000000,
      headers: {
        'Content-Type': 'application/json',
        Client: client,
        APP_VERSION: ApiVersion,
        Uid: Uid,
        'Access-Token': access,
      },
    },
  )
}
